import Vue from 'vue'

import store from '@/$plugins/store'
import http from '@/$plugins/http'
import i18n from '@/$plugins/i18n'
import vuelidate, { validators } from '@/$plugins/vuelidate'
import bootstrap from '@/$plugins/bootstrap'

import SCSS_VARIABLES from '@/assets/js/modules/scss-variables'

import MixinViewport from '@/components/mixins/Viewport'
import MixinScrollbarSuppressor from '@/components/mixins/ScrollbarSuppressor'

import 'lazysizes'

import '@/assets/js/app.js'
import '@/assets/css/app.scss'

// For more informations visit: https://vuejs.org/v2/api/
Vue.config.productionTip = false
Vue.config.performance = process.env.NODE_ENV === 'development'

Vue.prototype.window = window
Vue.prototype.document = document

document.documentElement.classList.add((process.env.ENV_NAME || '').toLowerCase())

new Vue({ // eslint-disable-line no-new
  store,
  http,
  i18n,
  vuelidate,
  bootstrap,
  el: '#app',
  mixins: [
    MixinViewport,
    MixinScrollbarSuppressor
  ],
  data: {
    env: {
      name: process.env.ENV_NAME,
      isDevelopment: process.env.NODE_ENV === 'development',
      isProduction: process.env.NODE_ENV === 'production',
      publicPath: process.env.BASE_URL,
      isTouch: 'ontouchstart' in window || window.navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0
    },
    scss: SCSS_VARIABLES,
    validators
  },
  methods: {
    isNullOrEmpty (value) {
      return value === null || value === undefined || value === '' || value === []
    },
    isBoolean (value) {
      return typeof value === 'boolean'
    }
  },
  mounted () {
    document.documentElement.classList.add(...['ready', this.env.isTouch ? 'is-touch' : null].filter(c => c))
  }
})
